import React from 'react';
import { object, string } from 'prop-types';

const QueryName = ({ data, value }) => {
   return (
      <div className={`${data.isEdited ? 'spark-bold' : ''}`}>
         {value.toUpperCase()}
      </div>
   );
};

QueryName.propTypes = {
   data: object,
   value: string,
};
export default QueryName;
